import Wearable from './Wearable'
export default Wearable
